import Bowser from 'bowser'
import { PYTHON_URL } from '../urls'
import { guardarDatosLogin } from './pythonAxios'

const url_registrar_login = 'autenticacion/registrar_login/';

export var obtenerDatos = (email_usuario, operacion, token, url, nombrePlataforma) => {
    
    //Obtener ip, pais y región.
    fetch(PYTHON_URL + url, {
        method: "GET",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => response.json())
        .then(data => { 
            //Obtener información del navegador.
            const browser = Bowser.getParser(window.navigator.userAgent);
            const browser_name = browser.getBrowserName();
            const os_name = browser.getOSName();
            const platform_type = browser.getPlatformType();

            //Objeto con información del usuario.
            const datosRegistrar = {
                email_usuario,
                pais: data.pais_nombre,
                region: data.region,
                ciudad: data.ciudad,
                browser_name,
                os_name,
                modulo: nombrePlataforma,
                platform_type,
                operacion,
                latitud: data.latitud,
                longitud: data.longitud
            };
            //Registrar login.
            guardarDatosLogin(url_registrar_login, datosRegistrar, token);

        }).catch(function (error) {  
            //Objeto con información por defecto.
             const datosRegistrar = {
                email_usuario,
                pais: 'Sin información',
                region: 'Sin información',
                ciudad: 'Sin información',
                browser_name: 'Sin información',
                os_name: 'Sin información',
                modulo: nombrePlataforma,
                platform_type: 'Sin información',
                operacion 
            };            

            guardarDatosLogin(url_registrar_login, datosRegistrar, token);
        });
}
